module.exports = __webpack_public_path__ + "img/sucTicket.be7a5771.png";